import { render, staticRenderFns } from "./GroupAuthors.vue?vue&type=template&id=30f6f06a&scoped=true"
import script from "./GroupAuthors.vue?vue&type=script&lang=js"
export * from "./GroupAuthors.vue?vue&type=script&lang=js"
import style0 from "./GroupAuthors.vue?vue&type=style&index=0&id=30f6f06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f6f06a",
  null
  
)

export default component.exports